import axiosInstance from "../axiosInstance";

export const kdlHealthService = {
  // Latest stored health result + state of any on-demand run.
  fetch: async () => {
    const response = await axiosInstance.get("/kdl-health");
    return response.data;
  },
  // Queue an on-demand run; the KDL host agent picks it up within ~1 minute.
  run: async () => {
    const response = await axiosInstance.post("/kdl-health", {});
    return response.data;
  },
};
